import LegendItem from './legendItem/LegendItem';
import React from 'react';

import './chartLegend.scss';

interface IListData {
    labels: Array<string>;
    data: Array<number>;
    colors: Array<string>;
}

const ChartLegend: React.FC<{ data: IListData }> = ({ data }) => {
    return (
        <div className='status-summary-body_chart-legend'>
            {data.labels.map((v, i) => {
                const legend = {
                    label: v,
                    color: data.colors[i],
                    data: data.data[i],
                };
                return <LegendItem data={legend} key={v}></LegendItem>;
            })}
        </div>
    );
};

export default ChartLegend;
